import { DateTime } from "luxon";
import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { useEffect, useState } from "react";

export const Countdown = ({
	data,
	date,
	hour,
	eventDateTime,
	setFinishTime,
}: {
	data: any;
	date: string;
	hour: string;
	eventDateTime: string;
	setFinishTime: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const [countdown, setCountdown] = useState<{ days: number; hours: number; minutes: number; seconds: number }>({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	const renderTime = (time: number, text: string) => {
		return (
			<Column
				key={text}
				crossAxisAlignment="center"
				mainAxisAlignment="center"
			>
				<TextComponent
					variant="h1"
					className="text-center font-lilita-one w-12"
				>
					{time < 10 ? `0${time}` : time}
				</TextComponent>
				<span className="text-orange-500 font-bold uppercase">{text}</span>
			</Column>
		);
	};
	useEffect(() => {
		const calculateCountdown = (eventDateTime: DateTime) => {
			const targetTime = eventDateTime.toMillis();
			const now = DateTime.now().toMillis();
			let remainingTime = targetTime - now;
			const interval = setInterval(() => {
				remainingTime -= 1000;
				const diffDays = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
				const diffHours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const diffMinutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
				const diffSeconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
				if (remainingTime <= 0) {
					setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
					setFinishTime(true);
					clearInterval(interval);
					return;
				}
				setCountdown({
					days: diffDays,
					hours: diffHours,
					minutes: diffMinutes,
					seconds: diffSeconds,
				});
			}, 1000);
		};
		calculateCountdown(DateTime.fromISO(eventDateTime));
	}, [eventDateTime, setFinishTime]);

	return (
		<>
			{!data?.results && data?.time && (
				<TextComponent
					variant="h3"
					className="text-black text-center"
				>
					El resultado será publicado el <br /> <strong>{date}</strong> a las <strong>{hour}</strong>
				</TextComponent>
			)}
			{data && !data?.results && (
				<Column
					className="gap-1 md:gap-2"
					crossAxisAlignment="center"
					mainAxisAlignment="center"
					flexible
				>
					<TextComponent
						variant="h4"
						className="text-gray-700"
					>
						Tiempo restante
					</TextComponent>
					<Row
						className="gap-2 md:gap-4 text-orange-600"
						mainAxisAlignment="center"
						crossAxisAlignment="center"
					>
						{countdown.days !== 0 && (
							<>
								{renderTime(countdown.days, "días")}
								<span className="font-extrabold">:</span>
							</>
						)}
						{countdown.hours !== 0 && (
							<>
								{renderTime(countdown.hours, "horas")}
								<span className="font-extrabold">:</span>
							</>
						)}
						{countdown.minutes !== 0 && (
							<>
								{renderTime(countdown.minutes, "min.")}
								<span className="font-extrabold">:</span>
							</>
						)}
						{renderTime(countdown.seconds, "seg.")}
					</Row>
				</Column>
			)}
		</>
	);
};
